export const getStripeRegistrationLink = 'Merchant/GetStripeRegistrationLink';
export const getStripeLoginLink = 'Merchant/GetStripeLoginLink';
